import * as GridCell from '../../grid-cell'
import * as Constants from '../constants'

export class PersonRoleActiveCell extends GridCell.ActiveCell {
  constructor(props: any) {
    super(props, Constants.UPDATE_PERSON_ROLE, false, true)
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/render/person_role_active_cell.tsx